import { makeAutoObservable } from "mobx"
import { getStockDetailData } from "../../../modules/quote/web"
import { getPageType, PageType } from "../../shared/pagetype"
import { ChartType } from "../../shared/utils"

class Store {
  constructor() {
    if (getPageType() == PageType.日本 || getPageType() == PageType.韩国 || getPageType() == PageType.台湾 || getPageType() == PageType.法国 || getPageType() == PageType.德国 || getPageType() == PageType.马来西亚) {
      makeAutoObservable(this)
      this.init()
    }
  }

  StockDetail: any = undefined

  chartType = ChartType.分时

  chart_mouse_move_data: any = null

  async init() {
    this.getData()

    // setInterval(() => {
    //   this.getData()
    // }, 30 * 1000)
  }

  async getData() {
    // let data = await getStockDetailData(window.quotedata.quotecode, "f43,f44,f45,f46,f47,f48,f50,f57,f58,f59,f60,f107,f116,f117,f130,f131,f132,f133,f152,f162,f164,f168,f169,f170,f177,f292")
    this.setStockDetail(undefined)
  }

  setStockDetail(StockDetail: any) {
    this.StockDetail = StockDetail
  }

  setChartType(chartType: ChartType) {
    this.chartType = chartType
  }

  setChartMouseMoveData(chart_mouse_move_data: any) {
    this.chart_mouse_move_data = chart_mouse_move_data
  }
}

export const store = new Store()
